/**
 * Game state.
 *
 * module app/components/crossSell/games/Game
 */
import DeviceDetector from '../../DeviceDetector';
import GameView from '../../crossSell/games/GameView';
import MessageBusTopics from '../../../../common/MessageBusTopics';

/**
 * Game state enumeration.
 */

var gameStateDefault = 0;
var gameStateOpening = 1;
var gameStateRestoring = 2;
var gameStateOpen = 3;
var gameStateMinimizing = 4;
var gameStateMinimized = 5;
var gameStateClosing = 6;

/**
 * Names of prototype properties.
 */

var publish = 'publish';
var gameState = 'gameState';
var view = 'view';
var restoreAction = 'restoreAction';
var openAction = 'openAction';
var closeAction = 'closeAction';
var minimizeAction = 'minimizeAction';
var paymentsAction = '';
var messageBus = 'messageBus';
var gameUrl = 'gameUrl';
var addPopState = 'addPopState';
var popState = 'popState';

/**
 * Create a game instance.
 * @constructor
 * @param {Object} theMessageBus Pub/sub instance.
 * @param {String} gameUrl Game launch URL.
 * @public
 */
var Game = function Game(theMessageBus, theGameUrl) {

    this[gameState] = gameStateDefault;
    this[messageBus] = theMessageBus;
    this[gameUrl] = theGameUrl;
    this.listen();
};

Game.prototype = {

    /**
     * Open the game.
     * @returns {void}
     * @public
     */
    open: function open() {

        if (this[gameState] === gameStateMinimized) {
            this[restoreAction]();
        } else {
            this[openAction]();
        }
    },

    /**
     * Subscribe to messages.
     * @returns {void}
     * @private
     */
    listen: function listen() {

        var self = this;

        this[messageBus].subscribe(MessageBusTopics.GAME_MINIMIZE, function () {

            self[closeAction]();
        });

        this[messageBus].subscribe(MessageBusTopics.GAME_IS_CLOSING, function () {

            self[closeAction]();
        });

        this[messageBus].subscribe(MessageBusTopics.CLOSE_GAME, function () {

            self[closeAction]();
        });

        this[messageBus].subscribe(MessageBusTopics.GAME_SHOW_PAYMENTS, function () {

            self[paymentsAction]();
        });
    },
};

/**
 * Publish a message bus topic.
 * @param {String} topic The topic.
 * @returns {void}
 * @private
 */
Game.prototype[publish] = function publish(topic) {

    this[messageBus].publish(topic);
};

/**
 * Listen for the popstate event.
 *
 * @returns {void}
 * @private
 */
Game.prototype[addPopState] = function addPopState() {

    var self = this;

    if (!DeviceDetector.isNative()) {

        window.addEventListener('popstate', function (event) {

            self[popState](event);
        });
    }
};

/**
 * Handle a popstate event.
 *
 * @returns {void}
 * @private
 */
Game.prototype[popState] = function popState() {

    if (!DeviceDetector.isNative() && this[gameState] === gameStateOpen) {

        this[minimizeAction]();
    }
};

/**
 * Restore the game.
 * @returns {void}
 * @private
 */
Game.prototype[restoreAction] = function restoreAction() {

    this[gameState] = gameStateRestoring;
    this[addPopState]();
    this[view].show();
    this[publish]('maximizeGame');
    window.location.hash = 'game';
    this[gameState] = gameStateOpen;
};

/**
 * Open the game.
 * @returns {void}
 * @private
 */
Game.prototype[openAction] = function openAction() {

    this[gameState] = gameStateOpening;
    this[addPopState]();
    this[view] = new GameView(this.messageBus, this[gameUrl]);
    this[publish]('maximizeGame');
    window.location.hash = 'game';
    this[gameState] = gameStateOpen;
};

/**
 * Behaviour when the user launches payments (deposit/withdraw).
 * @returns {void}
 * @private
 */
Game.prototype[paymentsAction] = function paymentsAction() {

    if (this[gameState] === gameStateOpen) {

        this.minimizeAction();
        window.history.go(-1);
    }
};

/**
 * Mimize the game.
 * @returns {void}
 * @private
 */
Game.prototype[minimizeAction] = function minimizeAction() {

    this[gameState] = gameStateMinimizing;
    this[view].hide();
    this[publish]('minimizeGame');
    this[gameState] = gameStateMinimized;
    window.location.hash = 'top-games';

};

/**
 * Close the game.
 * @returns {void}
 * @private
 */
Game.prototype[closeAction] = function closeAction() {

    this[gameState] = gameStateClosing;
    this[view].hide();
    this[view].destroy();
    this[gameState] = gameStateDefault;
};

export default Game;
